import { useEffect, useState } from "react";

const useResponsive = () => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(() => window.innerWidth > 768 && window.innerWidth <= 1024);
  const [isLaptop, setIsLaptop] = useState(() => window.innerWidth > 1024);

  const updateDeviceType = () => {
    const width = window.innerWidth;

    setIsMobile(width <= 768);
    setIsTablet(width > 768 && width <= 1024);
    setIsLaptop(width > 1024);
  };

  useEffect(() => {
    updateDeviceType();
    window.addEventListener("resize", updateDeviceType);

    return () => window.removeEventListener("resize", updateDeviceType);
  }, []);

  return { isMobile, isTablet, isLaptop };
};

export default useResponsive;
